import React from "react";
import Slider from "../slick-wrapper";
import { PropTypes } from "prop-types";
import styles from "./styles.css";

const CarouselBottomArrow = ({children, settings, afterChange, beforeChange = () => {}}) => {

    return (
        <div styleName={"styles.customCarousel"}>
            <Slider {...settings} afterChange={afterChange} beforeChange={beforeChange}>
                {children}
            </Slider>
        </div>
    );
};
CarouselBottomArrow.propTypes = {
    children: PropTypes.any,
    settings: PropTypes.object,
    afterChange: PropTypes.func,
    beforeChange: PropTypes.func
};
export default CarouselBottomArrow;
